module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"invalidtoken":"This link is no longer active"},"fr":{"invalidtoken":"Ce lien n\u0027est plus actif"}}')
  delete Component.options._Ctor
}
